import { createElement } from 'react';
import { RouteObject, redirect } from 'react-router-dom';

import { isHasAccess, pathPermissions, replacePermissions } from 'features/validateAccess';
import { pathKeys } from 'shared/lib/react-router';

import ExternalWarning from './ExternalWarningPage';

export const ExternalWarningRoute: RouteObject = {
  path: pathKeys.externalWarning(),
  element: createElement(ExternalWarning),
  loader: async (args) => {
    const requiredPermissions = replacePermissions(pathPermissions.dashboard, args.params);
    if (!isHasAccess(requiredPermissions)) {
      return redirect(pathKeys.dashboard());
    }

    return args;
  },
};
